import React from 'react'

// Semua SVG di ./svgs otomatis terdaftar sebagai icon (nama file = name prop).
// SVG digambar dengan fill="currentColor" supaya ikut warna teks (paritas FontAwesomeIcon).
const modules = import.meta.glob('./svgs/*.svg', {
  query: '?react',
  import: 'default',
  eager: true,
})

const ICONS = Object.fromEntries(
  Object.entries(modules).map(([filePath, component]) => [
    filePath.replace('./svgs/', '').replace('.svg', ''),
    component,
  ]),
)

// <Icon name="box" /> — default 1em mengikuti font-size, warna mengikuti teks.
// Nama yang tidak dikenal jatuh ke default.svg.
const Icon = ({ name, size = '1em', className, style }) => {
  const Svg = ICONS[name] || ICONS.default
  return <Svg width={size} height={size} className={className} style={style} aria-hidden="true" />
}

export default Icon
